module.exports = __webpack_public_path__ + "media/app/assets/specializations/priest/discipline-bcbf29ae11bcbb0282ffddd1a1b2ed00.png";